<template>
  <div>
    <klickart-analytics-header :breadcrumb="$t('locations.title')"></klickart-analytics-header>
    <div class="container no-padding">
      <div class="box no-padding">
        <locations-map v-if="dataLoaded"></locations-map>

        <header class="clearfix p-large">
          <span class="fz--medium pt--xsmall pulled-left">
            <span class="icon-kp-location-marker"></span>
            {{ $tc('locations.visitors', total.visits, { count: total.visits }) }}
            <span v-if="total.visits > 0">
              {{ $tc('locations.cities', total.cities, { count: total.cities }) }}
              {{ $tc('locations.countries', total.countries, { count: total.countries }) }}
            </span>
          </span>
          <div class="pulled-right">
            <input-search></input-search>
          </div>
        </header>
        <list v-if="total.visits > 0"></list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import KlickartAnalyticsHeader from './screens/Layout/components/KlickartAnalyticsHeader';
import LocationsMap from './screens/Locations/components/Map';
import List from './screens/Locations/components/List';
import InputSearch from './screens/Locations/components/Search';

export default {
  created() {
    this.getLocations(this.$route.params.pageIdentifier).then(() => {
      this.dataLoaded = true;
    });
  },
  components: {
    KlickartAnalyticsHeader,
    List,
    InputSearch,
    LocationsMap,
  },
  computed: mapGetters({
    total: 'locations/total',
  }),
  methods: mapActions({
    getLocations: 'locations/getLocations',
  }),
};
</script>



// WEBPACK FOOTER //
// src/Locations.vue